import React from "react";

const Page2 = () => {
  return (
    <div className="welcome-page">
      <section>
        <h2>Why most people fail to build a new habit?</h2>
        <p>
          <strong>Good habits show results in a long time</strong> and there is
          no immediate feedback on our daily actions.
        </p>
        <p>
          The book <strong>Atomic Habit</strong>, states that a simple
          calendar-based tracking would help build any habit for a long time.
        </p>
      </section>
    </div>
  );
};

export default Page2;
